import Immutable from 'immutable';

const initialState = Immutable.fromJS({
  trybeName: 'Public',
  coachName: null
});



module.exports = function(state = initialState, action={}) {
  switch(action.type) {
    case 'SET_TRYBE': {
      return state.set('trybeName', action.trybeName);
    }

    case 'SET_COACH_NAME': {
      return state.set('coachName', action.coachName);
    }

    default: {
      /* Return original state if no actions were consumed. */
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/analyticsReducer.js